module.exports = __webpack_public_path__ + "i18n/pt-BR.4332fd1217dad9de3a46a5a0141941c3.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/pt-BR.json
// module id = 1313
// module chunks = 59